export const typePin = {
  parental: 'Parental',
  purchase: 'Purchase',
};
export const COMPONENT_NAME = 'ParentalControl';
export const FULL_COMPONENT_NAME = `Settings.${COMPONENT_NAME}`;
